import request from '@/utils/request';
import requests from '@/utils/requests';

// 登录方法
export function login(data) {
  return requests({
    url: '/user/login',
    headers: {
      isToken: false,
      repeatSubmit: false,
    },
    method: 'post',
    data: data,
  });
}
// 登录方法2
export function loginByRegisNumber(data) {
  return requests({
    url: '/user/loginByRegistrationNumber',
    headers: {
      isToken: false,
      repeatSubmit: false,
    },
    method: 'post',
    data: data,
  });
}
// 登录方法3
export function loginByIdCard(data) {
  return requests({
    url: '/user/loginByIdCard',
    headers: {
      isToken: false,
      repeatSubmit: false,
    },
    method: 'post',
    data: data,
  });
}
//找回报名序号
export function findRegistrationNumber(data) {
  return requests({
    url: '/user/findRegistrationNumber',
    method: 'post',
    data: data,
  });
}

// 注册方法
export function register(data) {
  return request({
    url: '/user/register',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: data,
  });
}

/** 注册页：可报名考试下拉（名称模糊查询，每次最多 20 条） */
export function fetchRegisterExamOptions(keyword, examId) {
  const params = { keyword: keyword || '' };
  if (examId != null && examId !== '') {
    params.examId = examId;
  }
  return request({
    url: '/user/registerExamOptions',
    headers: {
      isToken: false,
    },
    method: 'get',
    params,
  });
}

/** 登录/找回密码：未删除考试下拉；loginType 有值时按登录方式过滤（重置密码传 3） */
export function fetchAllExamOptions(keyword, examId, loginType) {
  const params = { keyword: keyword || '' };
  if (examId != null && examId !== '') {
    params.examId = examId;
  }
  if (loginType != null && loginType !== '') {
    params.loginType = loginType;
  }
  return request({
    url: '/user/allExamOptions',
    headers: {
      isToken: false,
    },
    method: 'get',
    params,
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get',
  });
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post',
  });
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false,
    },
    method: 'get',
    timeout: 20000,
  });
}

//同步数据
export function synchronousData(data) {
  return requests({
    url: '/user/synchronous',
    method: 'post',
    data: data,
  });
}
//重置密码
export function resetPwd(data) {
  return requests({
    url: '/user/resetPwd',
    method: 'post',
    data: data,
  });
}
